import React from 'react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  const handleStartWorking = () => navigate('/explore');
  const handleSearchRoles = () => navigate('/explore');

  return (
    <section
      className="w-full flex flex-col items-center justify-center text-center"
      style={{
        backgroundColor: '#F9FBF5',
        minHeight: 'calc(100vh - 114px)',
        paddingTop: '80px',
        paddingBottom: '80px',
      }}
    >
      {/* Subtitle */}
      <p
        className="text-[16px] md:text-[18px] font-normal tracking-wide mb-4"
        style={{ color: '#0A3900' }}
      >
        Your AI platform to
      </p>

      {/* Main heading - dutyai.com large serif-like style */}
      <h1
        className="max-w-4xl px-6"
        style={{
          fontFamily: '"DM Sans", sans-serif',
          fontWeight: 400,
          color: '#082900',
          fontSize: 'clamp(40px, 7vw, 80px)',
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
        }}
      >
        Find work.<br />
        <span style={{ fontStyle: 'italic', fontWeight: 300 }}>Build your career.</span>
      </h1>

      {/* Description */}
      <p
        className="mt-8 max-w-xl px-6 text-[17px] md:text-[19px] leading-relaxed font-normal"
        style={{ color: '#0A3900', opacity: 0.8 }}
      >
        Access world-class opportunities from leading companies.
        Get matched, interviewed, and hired — all through AI.
      </p>

      {/* CTA Buttons - dutyai.com exact style */}
      <div className="mt-10 flex flex-col sm:flex-row items-center gap-4">
        <button
          className="alex-btn-primary text-[17px]"
          style={{ padding: '18px 40px', borderRadius: '8px' }}
          onClick={handleStartWorking}
        >
          Start working
        </button>
        <button
          className="alex-btn-outline text-[13px]"
          style={{ padding: '16px 28px' }}
          onClick={handleSearchRoles}
        >
          Search roles
        </button>
      </div>

      {/* Trusted by section */}
      <div className="mt-16 flex flex-col items-center gap-4">
        <p
          className="text-[13px] font-medium uppercase tracking-widest"
          style={{ color: '#0A3900', opacity: 0.4 }}
        >
          Trusted by leading companies
        </p>
        <div className="flex items-center gap-8 opacity-30">
          {['Google', 'Meta', 'Amazon', 'Microsoft', 'Apple'].map(name => (
            <span
              key={name}
              className="text-[15px] font-semibold tracking-wide"
              style={{ color: '#082900' }}
            >
              {name}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
